import SupplierStatus from './supplier-status';
export default SupplierStatus;